import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Text, View } from 'react-native';
// import { Auth } from '@aws-amplify/auth';

class Activate extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Activate';
  }

  componentDidMount() {
    const {
      match: { params: { username, code, redirect } }, history,
    } = this.props;

    try {
      Auth.confirmSignUp(username, code)
        .then((_data) => {
          console.log('success');
          history.push(redirect);
        })
        .catch((err) => {
          console.log(`User activation error: ${err}`);
          // history.push(redirect);
        });
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Text>
          User activation failed.
        </Text>
      </View>
    );
  }
}

Activate.defaultProps = {
  // match: { params: { username: '', code: '', redirect: '/' } },
};

Activate.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default Activate;
